import { useEffect, useState } from 'react';
import getCurrentSubscription from '../utils/stripe/getCurrentSubscription';

export function useSubscription(trigger = 0) {
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    getCurrentSubscription()
      .then(setSubscription)
      .catch(() => setSubscription(null));
  }, [trigger]);

  return subscription;
} 